import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthGuard, RoleGuard } from './shared/services';

const routes: Routes = [
  { path: 'home', loadChildren: 'app/home-management/home.module#HomeModule', canActivate: [AuthGuard] },
  { path: 'projects', loadChildren: 'app/projects-management/projects.module#ProjectsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_PROJECT'] } },
  { path: 'tiers', loadChildren: 'app/tiers-management/tiers.module#TiersModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_TIERS'] } },

  { path: 'data', loadChildren: 'app/data-management/data.module#DataModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_DATA'] } },

  { path: 'events', loadChildren: 'app/events-management/events.module#EventsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_EVENEMENT'] } },
  { path: 'commercials', loadChildren: 'app/commercials-management/commercials.module#CommercialsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_COMMERCIAL'] } },
  { path: 'settings', loadChildren: 'app/settings-management/settings.module#SettingsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_SETTING'] } },
  { path: 'graphs', loadChildren: 'app/graphs-management/graphs.module#GraphsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_REPORT'] } },
  { path: 'reports', loadChildren: 'app/reports-management/reports.module#ReportsModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_REPORT'] } },
  { path: 'sales', loadChildren: 'app/sales-management/sales.module#SalesModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_SALE'] } },
  { path: 'users', loadChildren: 'app/users-management/users.module#UsersModule', canActivate: [AuthGuard, RoleGuard], data: { roles: ['ROLE_USER','ROLE_PROFILE'] } },
  { path: 'auth', loadChildren: 'app/auth-management/auth.module#AuthModule' },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
